<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="系统名称">
                  <el-input v-model="queryForm.systemName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="系统code">
                  <el-input v-model="queryForm.systemCode" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="tr">
      <el-button type="primary" @click="showForm">添加系统</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="systemName" label="系统名称"></el-table-column>
      <el-table-column prop="systemCode" label="系统code"></el-table-column>
      <el-table-column prop="vendorCount" label="使用店铺数量"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">编辑</el-link>
          <el-link type="primary" @click="removeItem(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNum"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="form.vendorSystemId ? '编辑账号' : '创建账号'" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item prop="systemName" label="系统名称" :rules="[{ required: true, message: '请输入系统名称' }]">
          <el-input v-model="form.systemName" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item v-if="!form.vendorSystemId" prop="systemCode" label="系统code" :rules="[{ required: true, message: '请输入系统code' }]">
          <el-input v-model="form.systemCode" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">{{ form.vendorSystemId ? '保存' : '确认创建' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  createVendorSystem,
  updateVendorSystem,
  deleteVendorSystem,
  getListVendorSystem,
} from "./api";

export default {
  data() {
    return {
      queryForm: {
        systemCode: null,
        systemName: null,
        pageNum: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        vendorSystemId: null,
        systemCode: null,
        systemName: null,
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNum = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.systemName = null;
      this.queryForm.systemCode = null;
      this.queryForm.pageNum = 1;
      this.getTableData();
    },
    getTableData() {
      getListVendorSystem(this.queryForm).then(res => {
        if (res.data && res.data.data) {}
        this.total = res.data.data.total;
        this.tableData = res.data.data.records;
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNum) {
      this.queryForm.pageNum = pageNum;
      this.getTableData();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            let request = createVendorSystem;
            if (this.form.vendorSystemId) {
              request = updateVendorSystem;
            }
            request(this.form).then(res => {
              this.repeatSave = false;
              if (res.data.success) {
                this.$message.success('保存成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.data || res.data.message);
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    showForm() {
      this.form.vendorSystemId = null;
      this.form.systemCode = '';
      this.form.systemName = '';
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    editItem(row) {
      this.form.vendorSystemId = row.vendorSystemId;
      this.form.systemCode = row.systemCode;
      this.form.systemName = row.systemName;
      this.dialogVisible = true;
    },
    removeItem(row) {
      this.$confirm(`确认删除${row.systemName}吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteVendorSystem({
          systemId: row.vendorSystemId
        }).then((res) => {
          if (res.data && res.data.data) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getTableData();
          } else {
            this.$alert('该系统下还有商家在使用，请确认无商家使用后，再删除。', '', {
              confirmButtonText: '确定',
            });
          }
        })
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
</style>
